import { useToast as useChakraToast } from "@chakra-ui/react";

export function useToastNotification() {
  return useChakraToast({
    duration: 3000,
    variant: "solid",
    position: "bottom",
  });
}
